import { Tooltip } from '@material-ui/core';
import { ToggleButton } from '@material-ui/lab';
import CSS from 'csstype';
import React, { useState } from 'react';

import { disableSelectTextStyle } from '~/src/dash/components/text/common';
import { TooltipPlacement } from '~/src/dash/components/tooltips/common';
import { publicaColors } from '~/src/dash/utils/colors';

interface IIconToggleProps {
  activeBackgroundColor?: string;
  activeImagePath?: string; // undefined will inherit default
  activeImageStyle?: CSS.Properties; // undefined will inherit default. conversely this will replace default
  backgroundColor?: string;
  hoverColor?: string;
  imagePath: string;
  imageStyle?: CSS.Properties; // css inside the img element
  isActive: boolean;
  setIsActive: (isActive: boolean) => void;
  tooltipPlacement?: TooltipPlacement;
  tooltipText?: string;
}

export const IconToggle = ({
  activeBackgroundColor = publicaColors.honeydew,
  activeImagePath,
  activeImageStyle = {},
  backgroundColor = publicaColors.veryLightGray,
  hoverColor = publicaColors.lightGray,
  imagePath,
  imageStyle,
  isActive,
  setIsActive,
  tooltipPlacement = 'top',
  tooltipText,
}: IIconToggleProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  return (
    <Tooltip title={tooltipText || ''} placement={tooltipPlacement}>
      <ToggleButton
        style={{
          padding: 0,
          margin: 0,
          border: 0,
          backgroundColor,
        }}
        selected={isActive}
        onClick={() => setIsActive(!isActive)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={isActive ? activeImagePath || imagePath : imagePath}
          style={{
            height: '24px',
            borderRadius: '4px',
            backgroundColor: isActive
              ? activeBackgroundColor
              : isHovered
              ? hoverColor
              : backgroundColor,
            padding: '4px',
            ...disableSelectTextStyle,
            ...imageStyle,
            ...(isActive && activeImageStyle),
          }}
        />
      </ToggleButton>
    </Tooltip>
  );
};
